var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { ChevronLeftIcon, ExternalLinkIcon, XIcon } from '@heroicons/react/solid';
import Navigation from '@components/App/Navigation';
import { api } from '../../api/client';
var label = 'block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1';
var input = 'block w-full border border-gray-300 rounded-md shadow-sm px-3 py-2 text-sm focus:ring-indigo-500 focus:border-indigo-500';
// The looked-up fields the form shows, with their labels for the
// "filled in ..." note.
var citationFields = [
    ['title', 'title'],
    ['authors', 'authors'],
    ['doi', 'DOI'],
    ['isbn', 'ISBN'],
    ['year', 'year'],
    ['item_type', 'item type'],
    ['venue', 'venue'],
    ['volume', 'volume'],
    ['number', 'number'],
    ['pages', 'pages'],
    ['publisher', 'publisher'],
];
var sourceNames = {
    crossref: 'Crossref',
    datacite: 'DataCite',
    arxiv: 'arXiv',
    openlibrary: 'Open Library',
};
export var ItemDetail = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var id = useParams().id;
    var history = useHistory();
    var _m = useState(null), item = _m[0], setItem = _m[1];
    var _o = useState(''), newTag = _o[0], setNewTag = _o[1];
    var _p = useState([]), allTags = _p[0], setAllTags = _p[1];
    var _q = useState(false), saving = _q[0], setSaving = _q[1];
    var _r = useState(false), uploading = _r[0], setUploading = _r[1];
    var _s = useState(''), uploadError = _s[0], setUploadError = _s[1];
    var _t = useState(false), lookingUp = _t[0], setLookingUp = _t[1];
    var _u = useState(null), lookupNote = _u[0], setLookupNote = _u[1];
    // The form as it was before a lookup filled it in, for Undo.
    var _v = useState(null), beforeLookup = _v[0], setBeforeLookup = _v[1];
    var load = function () {
        api.getItem(id).then(setItem);
    };
    useEffect(function () {
        load();
    }, [id]);
    // Tag suggestions - api.listTags is cached, so this is one request per
    // page load at most.
    var loadTags = function () {
        api
            .listTags()
            .then(setAllTags)
            .catch(function () { return setAllTags([]); });
    };
    useEffect(loadTags, []);
    if (!item) {
        return null;
    }
    var field = function (key) { return function (e) {
        var _a;
        setItem(__assign(__assign({}, item), (_a = {}, _a[key] = e.target.value, _a)));
    }; };
    var save = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updated;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSaving(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, api.updateItem(item.id, {
                            title: item.title,
                            authors: item.authors,
                            doi: item.doi,
                            isbn: item.isbn,
                            year: item.year,
                            notes: item.notes,
                            source_url: item.source_url,
                            item_type: item.item_type,
                            venue: item.venue,
                            volume: item.volume,
                            number: item.number,
                            pages: item.pages,
                            publisher: item.publisher,
                        })];
                case 2:
                    updated = _a.sent();
                    setItem(updated);
                    setBeforeLookup(null);
                    setLookupNote(null);
                    return [3 /*break*/, 4];
                case 3:
                    setSaving(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // Fills the form from the looked-up citation, replacing whatever is
    // there - nothing is saved until Save, and Undo puts the form back.
    var lookupCitation = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, source, matched_by, metadata, updated, changed, _i, citationFields_1, _b, key, name_1, value, from, err_1, message;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setLookingUp(true);
                    setLookupNote(null);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, api.lookupCitation(item.id)];
                case 2:
                    _a = _d.sent(), source = _a.source, matched_by = _a.matched_by, metadata = _a.metadata;
                    updated = __assign({}, item);
                    changed = [];
                    for (_i = 0, citationFields_1 = citationFields; _i < citationFields_1.length; _i++) {
                        _b = citationFields_1[_i], key = _b[0], name_1 = _b[1];
                        value = metadata[key];
                        if (value === undefined || value === '' || value === 0 || value === item[key])
                            continue;
                        updated[key] = value;
                        changed.push(name_1);
                    }
                    from = ((_c = sourceNames[source]) !== null && _c !== void 0 ? _c : source) + " (matched by " + matched_by + ")";
                    if (changed.length === 0) {
                        setLookupNote({ text: "Found on " + from + " - everything already matches.", error: false });
                        return [2 /*return*/];
                    }
                    setBeforeLookup(item);
                    setItem(updated);
                    setLookupNote({
                        text: "Filled in " + changed.join(', ') + " from " + from + ". Review, then Save.",
                        error: false,
                    });
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _d.sent();
                    message = err_1.message;
                    setLookupNote({
                        text: message.startsWith('404')
                            ? "Couldn't find a confident match - no DOI, arXiv ID or ISBN in the file, and the title didn't match anything."
                            : 'Lookup failed - the citation service may be busy, try again in a moment.',
                        error: true,
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setLookingUp(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var undoLookup = function () {
        if (beforeLookup)
            setItem(beforeLookup);
        setBeforeLookup(null);
        setLookupNote(null);
    };
    var uploadFile = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var file, updated, err_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
                    if (!file)
                        return [2 /*return*/];
                    setUploading(true);
                    setUploadError('');
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, api.uploadItemFile(item.id, file)];
                case 2:
                    updated = _b.sent();
                    setItem(updated);
                    return [3 /*break*/, 5];
                case 3:
                    err_2 = _b.sent();
                    setUploadError(err_2.message);
                    return [3 /*break*/, 5];
                case 4:
                    setUploading(false);
                    e.target.value = '';
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var addTag = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updated;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!newTag.trim())
                        return [2 /*return*/];
                    return [4 /*yield*/, api.addTag(item.id, newTag.trim())];
                case 1:
                    updated = _a.sent();
                    setItem(updated);
                    setNewTag('');
                    loadTags();
                    return [2 /*return*/];
            }
        });
    }); };
    var removeTag = function (tagId) { return __awaiter(void 0, void 0, void 0, function () {
        var updated;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.removeTag(item.id, tagId)];
                case 1:
                    updated = _a.sent();
                    setItem(updated);
                    loadTags();
                    return [2 /*return*/];
            }
        });
    }); };
    var remove = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!window.confirm("Delete \"" + item.title + "\"?"))
                        return [2 /*return*/];
                    return [4 /*yield*/, api.deleteItem(item.id)];
                case 1:
                    _a.sent();
                    history.push('/library');
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Navigation, { loggedIn: true }),
        React.createElement("div", { className: "max-w-3xl mx-auto sm:px-6 lg:px-8 py-8" },
            React.createElement(Link, { to: "/library", className: "inline-flex items-center gap-1 text-sm text-gray-500 hover:text-indigo-600 mb-4" },
                React.createElement(ChevronLeftIcon, { className: "h-4 w-4", "aria-hidden": "true" }),
                "Back to library"),
            React.createElement("div", { className: "space-y-5 bg-white border border-gray-200 rounded-lg p-6" },
                React.createElement("div", { className: "flex flex-wrap items-center gap-3" },
                    React.createElement("button", { onClick: lookupCitation, disabled: lookingUp, className: "px-3 py-1.5 border border-indigo-300 text-sm font-medium rounded-md text-indigo-700 bg-indigo-50 hover:bg-indigo-100 disabled:opacity-50", title: "Find the title, authors, DOI and type from the PDF's DOI/arXiv ID/ISBN via Crossref, arXiv or Open Library" }, lookingUp ? 'Looking up...' : 'Look up citation'),
                    lookupNote && (React.createElement("p", { className: "text-xs " + (lookupNote.error ? 'text-red-600' : 'text-gray-600') },
                        lookupNote.text,
                        beforeLookup && (React.createElement("button", { onClick: undoLookup, className: "ml-2 text-indigo-600 hover:underline" }, "Undo"))))),
                React.createElement("div", null,
                    React.createElement("label", { className: label }, "Title"),
                    React.createElement("input", { className: input, value: item.title, onChange: field('title') })),
                React.createElement("div", null,
                    React.createElement("label", { className: label }, "Authors"),
                    React.createElement("input", { className: input, value: (_a = item.authors) !== null && _a !== void 0 ? _a : '', onChange: field('authors'), placeholder: "Last, First; Last, First" })),
                React.createElement("div", null,
                    React.createElement("label", { className: label }, "Source URL"),
                    React.createElement("div", { className: "flex gap-2" },
                        React.createElement("input", { className: input, value: (_b = item.source_url) !== null && _b !== void 0 ? _b : '', onChange: field('source_url'), placeholder: "https://..." }),
                        item.source_url && (React.createElement("a", { href: item.source_url, target: "_blank", rel: "noopener noreferrer", className: "px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-500 hover:text-indigo-600 hover:border-indigo-300 flex-shrink-0", title: "Open link" },
                            React.createElement(ExternalLinkIcon, { className: "h-4 w-4", "aria-hidden": "true" }))))),
                React.createElement("div", { className: "grid grid-cols-2 gap-4" },
                    React.createElement("div", null,
                        React.createElement("label", { className: label }, "DOI"),
                        React.createElement("input", { className: input, value: (_c = item.doi) !== null && _c !== void 0 ? _c : '', onChange: field('doi') })),
                    React.createElement("div", null,
                        React.createElement("label", { className: label }, "Year"),
                        React.createElement("input", { className: input, value: (_d = item.year) !== null && _d !== void 0 ? _d : '', onChange: field('year') }))),
                React.createElement("div", { className: "grid grid-cols-2 gap-4" },
                    React.createElement("div", null,
                        React.createElement("label", { className: label }, "Item Type"),
                        React.createElement("input", { className: input, value: (_e = item.item_type) !== null && _e !== void 0 ? _e : '', onChange: field('item_type'), placeholder: "journalArticle, book, thesis..." })),
                    React.createElement("div", null,
                        React.createElement("label", { className: label }, "Venue"),
                        React.createElement("input", { className: input, value: (_f = item.venue) !== null && _f !== void 0 ? _f : '', onChange: field('venue'), placeholder: "Journal or conference/book title" }))),
                React.createElement("div", { className: "grid grid-cols-3 gap-4" },
                    React.createElement("div", null,
                        React.createElement("label", { className: label }, "Volume"),
                        React.createElement("input", { className: input, value: (_g = item.volume) !== null && _g !== void 0 ? _g : '', onChange: field('volume') })),
                    React.createElement("div", null,
                        React.createElement("label", { className: label }, "Number"),
                        React.createElement("input", { className: input, value: (_h = item.number) !== null && _h !== void 0 ? _h : '', onChange: field('number') })),
                    React.createElement("div", null,
                        React.createElement("label", { className: label }, "Pages"),
                        React.createElement("input", { className: input, value: (_j = item.pages) !== null && _j !== void 0 ? _j : '', onChange: field('pages'), placeholder: "12-34" }))),
                React.createElement("div", null,
                    React.createElement("label", { className: label }, "Publisher"),
                    React.createElement("input", { className: input, value: (_k = item.publisher) !== null && _k !== void 0 ? _k : '', onChange: field('publisher') })),
                React.createElement("div", null,
                    React.createElement("label", { className: label }, "Notes"),
                    React.createElement("textarea", { className: input, rows: 4, value: (_l = item.notes) !== null && _l !== void 0 ? _l : '', onChange: field('notes') })),
                !item.file_type && (React.createElement("div", null,
                    React.createElement("label", { className: label }, "Attach a file"),
                    React.createElement("p", { className: "text-xs text-gray-500 mb-1" }, "This entry has no PDF/EPUB attached yet - add one you've downloaded by hand."),
                    React.createElement("input", { type: "file", accept: ".pdf,.epub,application/pdf,application/epub+zip", onChange: uploadFile, disabled: uploading, className: "text-sm" }),
                    uploading && React.createElement("p", { className: "text-xs text-gray-500 mt-1" }, "Uploading..."),
                    uploadError && React.createElement("p", { className: "text-xs text-red-600 mt-1" }, uploadError))),
                React.createElement("div", null,
                    React.createElement("label", { className: label }, "Projects / Tags"),
                    item.tags.length > 0 && (React.createElement("div", { className: "flex flex-wrap gap-1.5 mb-2" }, item.tags.map(function (t) { return (React.createElement("span", { key: t.id, className: "inline-flex items-center gap-1 pl-2 pr-1 py-0.5 text-xs rounded-full bg-indigo-100 text-indigo-800" },
                        t.name,
                        React.createElement("button", { onClick: function () { return removeTag(t.id); }, className: "rounded-full hover:bg-indigo-200 p-0.5", title: "Remove " + t.name },
                            React.createElement(XIcon, { className: "h-3 w-3", "aria-hidden": "true" })))); }))),
                    React.createElement("div", { className: "flex gap-2" },
                        React.createElement("input", { className: "flex-1 " + input, list: "item-tag-suggestions", value: newTag, onChange: function (e) { return setNewTag(e.target.value); }, onKeyDown: function (e) { return e.key === 'Enter' && addTag(); }, placeholder: "add to a project" }),
                        React.createElement("datalist", { id: "item-tag-suggestions" }, allTags
                            .filter(function (t) { return !item.tags.some(function (own) { return own.name === t.name; }); })
                            .map(function (t) { return (
                        // No label text: Firefox shows an option's label in
                        // place of its value, so a count label hid the name.
                        React.createElement("option", { key: t.name, value: t.name })); })),
                        React.createElement("button", { onClick: addTag, className: "px-3 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700" }, "Add"))),
                React.createElement("div", { className: "flex flex-wrap gap-3 pt-4 border-t border-gray-200" },
                    React.createElement("button", { onClick: save, disabled: saving, className: "px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50" }, "Save"),
                    item.file_type && (React.createElement("a", { href: api.fileUrl(item.id), className: "px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" }, "Download")),
                    React.createElement("a", { href: api.exportUrl(item.id), className: "px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" }, "Export to Markdown"),
                    React.createElement("a", { href: api.bibtexUrl(item.id), className: "px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" }, "Export to BibTeX"),
                    React.createElement("button", { onClick: remove, className: "px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 ml-auto" }, "Delete"))))));
};
export default ItemDetail;
